import { createContext, useContext, useState } from 'react';

// Define the context
type StepperContextType = {
    currentStep: number;
    steps: string[];
    nextStep: () => void;
    prevStep: () => void;
};

const StepperContext = createContext<StepperContextType | undefined>(undefined);

// Stepper component
type StepperProps = {
    steps: string[];
    initialStep?: number;
    children?: any;
};

export const Stepper= ({ steps, initialStep = 1, children }: StepperProps) => {
    const [currentStep, setCurrentStep] = useState<number>(initialStep);

    const nextStep = () => {
        if (currentStep <= steps.length) {
            setCurrentStep(currentStep + 1);
        }
    };

    const prevStep = () => {
        if (currentStep > 0) {
            setCurrentStep(currentStep - 1);
        }
    };

    return (
        <StepperContext.Provider value={{ currentStep, steps, nextStep, prevStep }}>
            {children}
        </StepperContext.Provider>
    );
};

// Hook to access stepper context
export const useStepper = () => {
    const context = useContext(StepperContext);
    if (!context) {
        throw new Error('useStepper must be used within a StepperProvider');
    }
    return context;
};
